import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import axiosInstance from '../../utils/axiosConfig';
import useTranslation from '../../utils/useTranslation';
import Reveal from '../Reveal';
import SectionViewAllLink from '../SectionViewAllLink';

export default function VocationalVideoSection({ innerRef }) {
  const { t, lang } = useTranslation();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    axiosInstance
      .get('public/system-static/', { params: { lang } })
      .then((res) => {
        if (!cancelled) setProject(res.data?.featured_project || null);
      })
      .catch(() => {
        if (!cancelled) setProject(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [lang]);

  if (!loading && !project) return null;

  return (
    <section className="section vocational" id="vocational" ref={innerRef}>
      <div className="container">
        {loading ? (
          <div className="spinner" />
        ) : (
          <Reveal as="article" className="featured-project-card">
            <div className="featured-project-grid">
              <div className="featured-project-meta">
                <h2 className="featured-project-title">{project.title}</h2>
                {project.overview ? (
                  <p className="featured-project-overview">{project.overview}</p>
                ) : null}
                <SectionViewAllLink
                  label={t('read_more')}
                  onClick={() => navigate(`/projects/${project.id}`)}
                />
              </div>
              <div className="featured-project-media">
                {project.image_url ? (
                  <img src={project.image_url} alt={project.title} loading="lazy" />
                ) : (
                  <div className="featured-project-media-empty" aria-hidden="true">
                    <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 5h13v14H6a2 2 0 0 1-2-2V5z" />
                      <path d="M17 8h3v9a2 2 0 0 1-2 2" />
                      <line x1="7" y1="8.5" x2="14" y2="8.5" />
                      <line x1="7" y1="12" x2="14" y2="12" />
                    </svg>
                  </div>
                )}
              </div>
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
